import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ScheduledNotificationsAPI from '../../api/scheduledNotifications';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getScheduledNotifications(_state) {
    return _state.records.sort((a, b) => b.id - a.id);
  },
  getScheduledNotificationById: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  get: async function getScheduledNotifications({ commit }) {
    commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isFetching: true });
    try {
      const response = await ScheduledNotificationsAPI.get();
      commit(types.SET_SCHEDULED_NOTIFICATIONS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createScheduledNotification({ commit }, data) {
    commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isCreating: true });
    try {
      const response = await ScheduledNotificationsAPI.create(data);
      commit(types.ADD_SCHEDULED_NOTIFICATION, response.data);
      return response.data;
    } finally {
      commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isUpdating: true });
    try {
      const response = await ScheduledNotificationsAPI.update(id, updateObj);
      commit(types.EDIT_SCHEDULED_NOTIFICATION, response.data);
      return response.data;
    } finally {
      commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isDeleting: true });
    try {
      await ScheduledNotificationsAPI.delete(id);
      commit(types.DELETE_SCHEDULED_NOTIFICATION, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isDeleting: false });
    }
  },

  cancel: async ({ commit }, id) => {
    commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isUpdating: true });
    try {
      const response = await ScheduledNotificationsAPI.cancel(id);
      commit(types.EDIT_SCHEDULED_NOTIFICATION, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isUpdating: false });
    }
  },

  resend: async ({ commit }, id) => {
    commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isUpdating: true });
    try {
      const response = await ScheduledNotificationsAPI.resend(id);
      commit(types.EDIT_SCHEDULED_NOTIFICATION, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SCHEDULED_NOTIFICATION_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_SCHEDULED_NOTIFICATION_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_SCHEDULED_NOTIFICATION]: MutationHelpers.create,
  [types.SET_SCHEDULED_NOTIFICATIONS]: MutationHelpers.set,
  [types.EDIT_SCHEDULED_NOTIFICATION]: MutationHelpers.update,
  [types.DELETE_SCHEDULED_NOTIFICATION]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
